module.exports = __webpack_public_path__ + "static/media/6.ad2c2959.jpg";